import jsonp from "common/js/jsonp.js";
import {commonParams,options} from "./config.js";
import axios from 'axios'

export function getFooterData(lang) {
	const url = 'api/getFooterData'

	const data = {lang:lang}
	return axios.get(url, {
    	params: data
  	}).then((res) => {
    	return Promise.resolve(res.data)
  	})
}


// WEBPACK FOOTER //
// ./src/api/footer.js